import React from 'react';
import { Badge as MUIBadge, BadgeProps as MUIBadgeProps } from '@mui/material';

export const Badge = (props: MUIBadgeProps) => {
  return <MUIBadge {...props} />;
};
